import getCookieValue from './getCookieValue';
import logger from './logger';

const getForterToken = (): string => {
    if (window.forterToken) {
        return window.forterToken;
    }

    logger.showLog('error', 'ForterToken was not found in window object. Using cookie value as fallback.');

    const forterTokenInCookie = getCookieValue('forterToken');
    if (forterTokenInCookie) {
        return forterTokenInCookie;
    }

    logger.showLog('error', 'ForterToken was not found in cookie');

    return '';
};

export default getForterToken;
